const storage = 'fiat'

export const getCity = () => localStorage.getItem(storage)

export const setCity = (city: string) => localStorage.setItem(storage, city)
